import React, { useState } from "react";
import { CheckCircle2Icon } from "lucide-react";
import { Field } from "../forms/Field";
import { inputClass, isEmail } from "../../utils/formStyles";
import { missions } from "../../data/pages";
const days = ["Vendredi 23", "Samedi 24", "Dimanche 25"];
type Errors = Partial<Record<"name" | "email" | "mission" | "days", string>>;
export function VolunteerForm() {
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    mission: "",
    days: [] as string[]
  });
  const [errors, setErrors] = useState<Errors>({});
  const [status, setStatus] = useState<"idle" | "sending" | "success">("idle");
  const toggleDay = (d: string) => setForm(f => ({
    ...f,
    days: f.days.includes(d) ? f.days.filter(x => x !== d) : [...f.days, d]
  }));
  const submit = (e: React.FormEvent) => {
    e.preventDefault();
    const next: Errors = {};
    if (!form.name.trim()) next.name = "Indiquez votre nom.";
    if (!isEmail(form.email)) next.email = "Adresse e-mail invalide.";
    if (!form.mission) next.mission = "Choisissez une mission.";
    if (form.days.length === 0) next.days = "Sélectionnez au moins un jour.";
    setErrors(next);
    if (Object.keys(next).length) return;
    setStatus("sending");
    window.setTimeout(() => setStatus("success"), 900);
  };
  if (status === "success") {
    return <div className="flex flex-col items-start rounded-[28px] bg-white p-8 md:p-10" role="status" data-id="element-205" data-mp="h07rsc3br5qc">
        <CheckCircle2Icon className="h-10 w-10 text-red" data-id="element-206" data-mp="vp3wbz66a0m7" />
        <h3 className="mt-4 font-serif text-3xl" data-id="element-207" data-mp="qs3pvn5euvuk">Merci {form.name.split(" ")[0]} !</h3>
        <p className="mt-2 text-navy-soft" data-id="element-208" data-mp="14r3c6o5gaynk">Votre candidature est enregistrée. L'équipe bénévoles vous recontactera par e-mail.</p>
      </div>;
  }
  return <form onSubmit={submit} noValidate className="space-y-5 rounded-[28px] bg-white p-6 md:p-10" data-id="element-209" data-mp="10qjenjgytt0w">
      <div className="grid gap-5 md:grid-cols-2" data-id="element-210" data-mp="36izzsw4w7yyp">
        <Field id="v-name" label="Nom complet" error={errors.name} data-id="element-211" data-mp="32hmwott6q9vh">
          <input id="v-name" className={inputClass} value={form.name} onChange={e => setForm({
          ...form,
          name: e.target.value
        })} aria-invalid={!!errors.name} aria-describedby={errors.name ? "v-name-error" : undefined} data-id="element-212" data-mp="32jhc5slot9s6" />
        </Field>
        <Field id="v-email" label="E-mail" error={errors.email} data-id="element-213" data-mp="1feeupi0agwhk">
          <input id="v-email" type="email" className={inputClass} value={form.email} onChange={e => setForm({
          ...form,
          email: e.target.value
        })} aria-invalid={!!errors.email} aria-describedby={errors.email ? "v-email-error" : undefined} data-id="element-214" data-mp="1kdrkobmgijod" />
        </Field>
      </div>
      <Field id="v-phone" label="Téléphone" optional data-id="element-215" data-mp="1tcmq3lhofpqm">
        <input id="v-phone" type="tel" className={inputClass} value={form.phone} onChange={e => setForm({
        ...form,
        phone: e.target.value
      })} data-id="element-216" data-mp="1y4mmj3yjg0ig" />
      </Field>
      <Field id="v-mission" label="Mission souhaitée" error={errors.mission} data-id="element-217" data-mp="236bu29mjxw1s">
        <select id="v-mission" className={inputClass} value={form.mission} onChange={e => setForm({
        ...form,
        mission: e.target.value
      })} aria-invalid={!!errors.mission} aria-describedby={errors.mission ? "v-mission-error" : undefined} data-id="element-218" data-mp="284wzcngnv5x3">
          <option value="" data-id="element-219" data-mp="3sle94t05rxn3">Choisir…</option>
          {missions.map(m => <option key={m.id} value={m.id} data-id="element-220" data-mp="3snh9a5v0z75j">{m.title}</option>)}
        </select>
      </Field>
      <fieldset data-id="element-221" data-mp="3no4mtm82g23h">
        <legend className="mb-2 text-sm font-medium" data-id="element-222" data-mp="3ingkw5iau0uh">Disponibilités</legend>
        <div className="flex flex-wrap gap-2" data-id="element-223" data-mp="3ipba3w0lsf4d">
          {days.map(d => {
          const on = form.days.includes(d);
          return <button key={d} type="button" aria-pressed={on} onClick={() => toggleDay(d)} className={`rounded-full border px-4 py-2 text-sm font-medium transition-colors duration-150 ${on ? "border-navy bg-navy text-cream" : "border-navy/20 text-navy hover:border-navy"}`} data-id="element-224" data-mp="f6865uivbh3z">
                {d}
              </button>;
        })}
        </div>
        {errors.days && <p className="mt-1.5 text-sm text-red" data-id="element-225" data-mp="y5c9qnrn4io9">{errors.days}</p>}
      </fieldset>
      <button type="submit" disabled={status === "sending"} className="w-full rounded-full bg-red px-6 py-4 font-semibold text-white transition-colors duration-150 hover:bg-red-deep disabled:opacity-60" data-id="element-226" data-mp="y3j3h9kxw0gs">
        {status === "sending" ? "Envoi en cours…" : "Envoyer ma candidature"}
      </button>
    </form>;
}